import { useSearchParams } from "react-router";
import { useAuth } from "../../../lib/auth";
import { useAppPreferences } from "../../../lib/preferences";
import { AccountDeletionRequestsPanel } from "../../admin-workspace/AccountDeletionRequestsPanel";
import { PlatformTeamPanel } from "../../admin-workspace/PlatformTeamPanel";
import { ReviewModerationPanel } from "../../admin-workspace/ReviewModerationPanel";
import { PageHeader } from "../ui";

export function ModerationPage() {
  const { t } = useAppPreferences();
  const [params, setParams] = useSearchParams();
  const type = params.get("type") === "reports" ? "reports" : "reviews";
  return (
    <div className="console-page">
      <PageHeader
        description={t("Publish or reject player reviews, and resolve reports about reviews and their authors.")}
        kicker={t("Work")}
        title={t("Moderation")}
      />
      <div aria-label={t("Moderation queues")} className="console-tabs" role="tablist">
        {(["reviews", "reports"] as const).map((tab) => (
          <button aria-selected={type === tab} className="console-tab" key={tab} onClick={() => setParams({ type: tab })} role="tab" type="button">
            {tab === "reviews" ? t("Reviews") : t("Reports")}
          </button>
        ))}
      </div>
      <div className="console-legacy">
        <ReviewModerationPanel key={type} show={type} />
      </div>
    </div>
  );
}

export function DeletionRequestsPage() {
  const { t } = useAppPreferences();
  const { user } = useAuth();
  return (
    <div className="console-page">
      <PageHeader
        description={t("Players asking gaamed to delete their account. Deleting is permanent and anonymizes their retained records.")}
        kicker={t("Work")}
        title={t("Deletion requests")}
      />
      <div className="console-legacy">
        <AccountDeletionRequestsPanel canApprove={user?.role === "admin"} />
      </div>
    </div>
  );
}

export function TeamPage() {
  const { t } = useAppPreferences();
  return (
    <div className="console-page">
      <PageHeader kicker={t("Platform")} title={t("Team")} description={t("Who can use this console, and what they can do.")} />
      <div className="console-legacy">
        <PlatformTeamPanel />
      </div>
    </div>
  );
}
